import {
  calculateGrossMarginFromUnitPrice,
  calculateUnitPriceFromGrossMargin,
} from '@calculations/price/utilities/gross-margin';

import {
  OnGrossMarginChangeInput,
  OnGrossMarginChangeOutput,
  OnUnitCostChangeInput,
  OnUnitCostChangeOutput,
  OnUnitPriceChangeInput,
  OnUnitPriceChangeOutput,
  RecalculatePriceStrategy,
} from '../types';
import { noOpQuantityChange, noOpQuotePriceCreation } from './no-op';

function onUnitCostChange({
  state,
  quotePrice,
  unitCost,
}: OnUnitCostChangeInput): OnUnitCostChangeOutput {
  if (!quotePrice.grossMargin) {
    return {
      status: 'failure',
      reason: 'No gross margin found',
    };
  }

  const unitPrice = calculateUnitPriceFromGrossMargin(
    {
      unitCost,
      grossMargin: quotePrice.grossMargin,
    },
    state.calculationConfig,
  );

  return {
    status: 'success',
    unitPrice,
  };
}

function onUnitPriceChange({
  quotePrice,
  unitPrice,
  state,
}: OnUnitPriceChangeInput): OnUnitPriceChangeOutput {
  if (!quotePrice.unitCost) {
    return {
      status: 'failure',
      reason: 'No unit cost found',
    };
  }

  const grossMargin = calculateGrossMarginFromUnitPrice(
    {
      unitCost: quotePrice.unitCost,
      unitPrice,
    },
    state.calculationConfig,
  );

  return {
    status: 'success',
    grossMargin,
  };
}

function onGrossMarginChange({
  state,
  quotePrice,
  grossMargin,
}: OnGrossMarginChangeInput): OnGrossMarginChangeOutput {
  if (!quotePrice.unitCost) {
    return {
      status: 'failure',
      reason: 'No gross margin found',
    };
  }

  const unitPrice = calculateUnitPriceFromGrossMargin(
    {
      unitCost: quotePrice.unitCost,
      grossMargin,
    },
    state.calculationConfig,
  );

  return {
    status: 'success',
    unitPrice,
  };
}

export const recalculateNewPartUserCost = {
  onQuantityChange: noOpQuantityChange,
  onUnitPriceChange: onUnitPriceChange,
  onGrossMarginChange: onGrossMarginChange,
  onContributionMarginChange: null,
  onBaseGrossMarginChange: null,
  onQuotePriceCreation: noOpQuotePriceCreation,
  onUnitCostChange,
} satisfies RecalculatePriceStrategy;
